import { ApplicationState } from "../index";

export function getById(id: string) {
  return (state: ApplicationState) =>
    state.cert.data?.data?.find(x => x.id === id);
}

export function getPEMFormat(cert: string | undefined, isCSR?: boolean) {
  const endCert = isCSR ? '-----END CERTIFICATE REQUEST-----' : '-----END CERTIFICATE-----';
  const beginCert = isCSR ? '-----BEGIN CERTIFICATE REQUEST-----' : '-----BEGIN CERTIFICATE-----';

  let pem = '';
  cert && cert.trim().length > 0 && cert.split(endCert)
    .map((value) => (value ? value.replace(beginCert, '') : undefined))
    .filter(Boolean)
    .forEach((element) => {
      if (element) {
        pem += `${beginCert}\r\n${formatPEM(element)}\r\n${endCert}\r\n`;
      }
      // console.log(pem);
    });
  return pem;
}

function formatPEM(pemString: string) {
  const PEM_STRING_LENGTH = pemString.length;
  const LINE_LENGTH = 64;
  const wrapNeeded = PEM_STRING_LENGTH > LINE_LENGTH;

  if (wrapNeeded) {
    let formattedString = '';
    let wrapIndex = 0;

    for(let i = LINE_LENGTH; i < PEM_STRING_LENGTH; i += LINE_LENGTH) {
      formattedString += pemString.substring(wrapIndex, i) + '\r\n';
      wrapIndex = i;
    }

    formattedString += pemString.substring(wrapIndex, PEM_STRING_LENGTH);
    return formattedString;
  } else {
    return pemString;
  }
}
